import { LanguageService } from '@/services';
import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { SpinnerButtonConfig } from '@/ui/spinner-button/spinner-button-config';

@Component({
    selector: 'app-notification-card',
    templateUrl: './notification-card.component.html',
    styleUrls: ['./notification-card.component.scss'],
    animations: [
        trigger('animation', [
            transition(':enter', [
                style({ transform: 'translateX(300px)' }),
                animate('500ms ease-in-out', style({ transform: 'translateX(0px)' })),
            ]),
            transition(':leave', [
                style({ transform: 'translateX(0px)' }),
                animate('500ms ease-in-out', style({ transform: 'translateX(300px)' })),
            ]),
        ]),
    ],
    standalone: false
})
export class NotificationCardComponent implements OnChanges {
  btnConfig: SpinnerButtonConfig = {
    text: `Ja`,
    type: 'flat',
    textColor: 'white',
  };

  @Input() titleText: string = '';
  @Input() descriptionText: string = '';
  @Input() cancelButton: boolean = false;
  @Input() okButton: boolean = false;
  @Input() cancelButtonText: string = '';
  @Input() okButtonText: string = '';

  @Output() onCancelClick = new EventEmitter<any>();
  @Output() onOkClick = new EventEmitter<any>();

  constructor(private languageService: LanguageService) {
    this.btnConfig.text = this.languageService.translateWithCap('general.words.yes');
  }

  onOkClickEvent() {
    this.btnConfig.loading = true;
    this.onOkClick.emit();
  }
  onCancelClickEvent() {
    this.onCancelClick.emit();
  }
  ngOnChanges(event: any) {
    this.btnConfig.text = event.okButtonText.currentValue;
  }
}
